module.exports = __webpack_public_path__ + "img/informatic.9cd0f06a.jpg";